import { YayLogo } from "./YayLogo";

interface CapacityScreenProps {
  /**
   * Re-check the cost gate: if the server is accepting again, rejoin (or
   * drop back to the join overlay); otherwise stay on the screen.
   */
  onRetry: () => void;
}

/**
 * Full-viewport "yay is at capacity" screen (cost gate, §3). Shown when the
 * server refuses new joins (monthly budget past the soft line) or the
 * operator flipped maintenance. Same visual language as the kicked screen:
 * solid brand purple, white logo + title, warm honest copy. Terminal like
 * kicked — no auto-reconnect; the user retries when they're ready.
 */
export function CapacityScreen({ onRetry }: CapacityScreenProps) {
  return (
    <div className="capacity-screen">
      <div className="capacity-card">
        <YayLogo variant="white" className="capacity-logo" />
        <h1 className="capacity-title">yay is at capacity right now</h1>
        <p className="capacity-reason">
          There's a surge of watchers and the room is full for today.
          <br />
          Come back in a bit — it should be open again.
        </p>
        <div className="capacity-actions">
          <button type="button" className="btn-kicked-primary" onClick={onRetry}>
            Try again
          </button>
        </div>
      </div>
    </div>
  );
}
